<template>
  
  <div class="flex flex-column pl-2 pr-2">

      <div class="mt-2 mb-2 flex align-items-center flex-column md:justify-content-between md:flex-row">
        <h2 v-if="this.$route.params.typ == 1" class="">ZOZNAM ŽIADANÝCH REZERVÁCIÍ PROFILOV</h2>
        <h2 v-if="this.$route.params.typ == 2" class="">ZOZNAM ŽIADANÝCH PROFILOV NA PRESTRIEKANIE</h2>
        <div class="flex align-items-center">
            <router-link v-if="(store.user.admin === true || store.user.department.id == 3) && this.$route.params.typ == 1" 
                to="/mod-stock/reservation-requests/1/0" class="mr-2">
                <PrimevueButton label="Pridať žiadosť o rezerváciu" severity="success" icon="pi pi-plus" text raised class="uppercase"/>
            </router-link>
            <router-link v-if="(store.user.admin === true || store.user.department.id == 3) && this.$route.params.typ == 2" 
                to="/mod-stock/reservation-requests/2/0" class="mr-2">
                <PrimevueButton label="Pridať žiadosť o prestriekanie" severity="success" icon="pi pi-plus" text raised class="uppercase"/>
            </router-link>
        </div>
      </div>
      <DataTable
          :class="['mobile-table', { 'compact': isMobile }]"
          lazy paginator :rows="this.pagination.rows"
          @page="onPage"
          :first="this.pagination.first"
          :loading="loading"
          :totalRecords="this.pagination.totalRecords"
          dataKey="id"
          :value="this.reservationRequests"
          v-model:filters="filters"
          @filter="onFilter"
          filterDisplay="row" 
          :globalFilterFields="globalFilterFields"
          stripedRows
          row-hover
          scrollable
          v-model:selection="this.selectedReservationRequest"
          selectionMode="single"
          :metaKeySelection="false"
          @rowSelect="showDetail(this.selectedReservationRequest.id)"
          tableStyle="min-width: 20rem"
          :virtualScrollerOptions="{ itemSize: 60 }"
          :scrollHeight="`${this.vh - 420}px`"
      >
        <template #header>

        </template>
        
        <Column header="Objednávka" style="min-width: 6%">
          <template #body="slotProps">
            {{ slotProps.data.order.orderCode }}
          </template>
        </Column>

        <Column header="Zákazník" style="min-width: 10%">
          <template #body="slotProps">
            {{ slotProps.data.order.customerLastName }} {{ slotProps.data.order.customerFirstName }}
          </template>

        </Column>

        <Column field="status" header="Status" style="min-width: 4%">
          <template #body="slotProps">
            <PrimevueTag class="justify-content-center" :class="`${this.isMobile ? 'font-normal text-xs' : 'font-medium text-base'}`"
              :value="slotProps.data.status"
              :severity="slotProps.data.status == 'Nová' ? 'primary' : (slotProps.data.status == 'Rozpracovaná' ? 'warning' : 'success')" />
          </template>

        </Column>
        
        <Column header="Dátum pridania" style="min-width: 4%">
          <template #body="slotProps">
            {{ Utils.parseToSlovakDate(slotProps.data.createdAt) }}
          </template>
        </Column>

        <Column header="Dátum vybavenia" style="min-width: 4%">
          <template #body="slotProps">
            {{ slotProps.data.executedAt != '0001-01-01T00:00:00Z' ? Utils.parseToSlovakDate(slotProps.data.executedAt) : "" }}
          </template>
        </Column>

        <!--
        <Column header="" style="min-width: 1%">
          <template #body="slotProps">

            <PrimevueButton v-if="store.user.admin === true || store.user.department.id == 3" 
                            type="button" v-tooltip.top="{ value: 'Odstránenie žiadosti o rezerváciu' }" 
                            icon="pi pi-trash" class="pack reserve"
                            @click="confirmDelete(slotProps.data.id)" text severity="danger" size="small"/>
 
          </template>
        </Column>
        -->
      </DataTable>
  </div>
  <ConfirmDialog></ConfirmDialog>

</template>

<script lang="ts">

//import IconField from 'primevue/iconfield';
import {store} from "@/components/store";
import Security from "@/components/security";
import DataTable from "primevue/datatable";
import Column from "primevue/column";
import router from "@/router";
import {FilterMatchMode} from "primevue/api";
import PrimevueTag from "primevue/tag";
//import InputIcon from "primevue/inputicon";
import notie from "notie/dist/notie";
import PrimevueButton from "primevue/button";
import Utils from '@/components/utils';
//import {emiter} from '../main';

export default {
  components: {
    DataTable,
    Column,
    //IconField,
    PrimevueTag,
    //InputIcon,
    PrimevueButton

  },
  name: "ReservationRequestList",
  data() {
    return {
      store,
      vh: 0,
      routeParams: null,
      isMobile: window.innerWidth <= 768,
      selectedReservationRequest: null,
      reservationRequests: [],
      filters: {
        global: {value: null, matchMode: FilterMatchMode.CONTAINS},
        customerName: {value: null, matchMode: FilterMatchMode.CONTAINS},
        orderCode: {value: null, matchMode: FilterMatchMode.CONTAINS},
      },
      filterFields: [  {field: 'Order__OrderCode',value: ""},
                       {field: 'Order__CustomerLastName',value: ""},

                    ],
      globalFilterFields: ['Order__OrderCode', 'Order__CustomerLastName'],
      categories: [],
 
      loading: true,

      pagination: {
        first: 0,
        rows: 15,
        totalRecords: 0, 
        filters: {},
      },
    }
  },

  computed: {
    Utils() {
      return Utils
    },
  },

  beforeMount() {
    if (Security.requireToken()){
      
      this.routeParams = this.$route.params
      store.selectModul = this.$route.path.split("/")[1]
      this.setDynamicHeight(); 
      // Aktualizácia výšky pri zmene veľkosti okna
      window.addEventListener("resize", this.setDynamicHeight);
      window.addEventListener("resize", this.checkViewport);
       
      //this.initFilters()

      this.loadComponent()
    }
  },

  beforeRouteUpdate(to, from, next) {
      if (Security.requireToken()){
        
        this.routeParams = to.params
        console.log("Route:", this.routeParams);
        store.selectModul = this.$route.path.split("/")[1]

        this.loadComponent() 

        next()
      }
  },

  
  beforeUnmount() {

    window.removeEventListener("resize", this.setDynamicHeight);
    window.removeEventListener("resize", this.checkViewport);
  },

  methods: {
    setDynamicHeight() {
      this.vh = window.innerHeight; // Nastavenie viditeľnej výšky
    },
    checkViewport() {
      this.isMobile = window.innerWidth <= 768;
    },
 
    showDetail(id:number) {
      router.push('/mod-stock/reservation-requests/'+this.routeParams.typ+'/'+ String(id))
    },
    
    onPage(event) {
        this.pagination.first = event.first; 

        this.loadLazyData(this.routeParams.typ == 1 ? this.store.basicUrlReservationRequests : this.store.basicUrlSprayingRequests,this.pagination);
    },

    loadComponent(){

      this.pagination.first = 0
      this.pagination.totalRecords = 0

      this.loadLazyData(this.routeParams.typ == 1 ? this.store.basicUrlReservationRequests : this.store.basicUrlSprayingRequests,this.pagination)

    },
    initFilters(){
        this.pagination.filters.filterFields = this.filterFields
        this.pagination.filters.global = ""
        this.pagination.filters.table = "reservation_request"
        this.pagination.filters.globalFilterFields = this.globalFilterFields;

    },
    onFilter(event) {
        if(event.filters){
          //console.log("Event:", event);
           this.pagination.filters.filterFields = [ {field: 'Order__OrderCode',value: event.filters.orderCode.value ? event.filters.orderCode.value : ""},
                                                   
                                                    {field: 'Order__CustomerLastName',value: event.filters.categoryName.value ? event.filters.categoryName.value.label: ""},
                                                   
                                                  ];
           this.pagination.filters.global = event.filters.global.value                                        
        }else{
          this.pagination.filters.filterFields = this.filterFields
          this.pagination.filters.global = this.filters.global.value
          //console.log("Filters:", this.pagination.filters);
        }
        this.pagination.filters.globalFilterFields = this.globalFilterFields;
        this.pagination.first = 0;  // Reset to the first page
        //console.log("Filters:", this.pagination.filters);
        this.loadLazyData(this.routeParams.typ == 1 ? this.store.basicUrlReservationRequests : this.store.basicUrlSprayingRequests,this.pagination);
    },
    
    loadLazyData(route,params) {
      
      this.loading = true;

      let queryParams = `&limit=${params.rows}&offset=${(params.first)}`;
      

      let info = this.routeParams.typ == 1 ? "Zoznam žiadostí o rezervácie je prázdny" : "Zoznam žiadostí o prestriekanie je prázdny"


      fetch(`${store.Api_url}${route}${queryParams}`, Security.requestOptions("GET"))
          .then(response => response.json())
          .then(responseData => {
            if (responseData.error) {
             
              //this.$emit('error', responseData.message);
              notie.alert({
                    type: 'error',
                    text: responseData.message,
                    position: "top"
                  })           
            } else {
              if(responseData.data){
                  this.reservationRequests = responseData.data;

                }else{
                    notie.alert({
                    type: 'info',
                    text: info,
                    position: "top"
                  })
                  this.reservationRequests = []
                }
              this.pagination.totalRecords = responseData.totalRecords;
              this.loading = false;
            }
          })
          .catch(error => {
            
            notie.alert({
                    type: 'error',
                    text: "Chyba pri načítaní žiadostí: "+error,
                    position: "top"
                  })
            this.loading = false;
          });
    }
  }

}
</script>

<style>


</style>